import { Pagination as MantinePagination } from '@mantine/core';

export const Pagination = MantinePagination.extend({
	defaultProps: {
		dotsIcon: () => '...',
		firstIcon: () => '<<',
		lastIcon: () => '>>',
		previousIcon: () => '<',
		nextIcon: () => '>',
		hideWithOnePage: true,
		withEdges: true,
		siblings: 0,
	},
});
